import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { useRecoilState } from 'recoil';
import { CloseIconButton } from '@nooz-optics/nooz-components-lib';
import { modalState } from '../../../../utils/recoil/modal';

export const Modal = () => {
  const [modal, setModal] = useRecoilState(modalState);

  const closeModal = () => {
    setModal({ ...modal, show: false });
  };

  const returnModalPlacement = () => {
    if (modal.placement === 'top-right') {
      return 'top-2 right-2';
    } else if (modal.placement === 'top-left') {
      return 'top-2 left-2';
    } else if (modal.placement === 'bottom-right') {
      return 'bottom-20 right-2';
    } else if (modal.placement === 'bottom-left') {
      return 'bottom-2 left-2';
    } else if (modal.placement === 'top-center') {
      return 'top-0 inset-x-0';
    } else if (modal.placement === 'bottom-center') {
      return 'bottom-0 inset-x-0';
    } else if (modal.placement === 'center') {
      return 'inset-0 flex items-center justify-center';
    }
  };

  return (
    <Transition
      as={Fragment}
      show={modal.show}>
      <div
        aria-live='assertive'
        className={`fixed ${returnModalPlacement()} z-50`}
        aria-labelledby='modal-title'
        role='dialog'
        aria-modal='true'>
        <div className='flex items-end justify-center pt-4 px-4 text-center sm:block'>
          {modal.hasOverlay && (
            <Transition.Child
              as={Fragment}
              enter='ease-out duration-300'
              enterFrom='opacity-0'
              enterTo='opacity-100'
              leave='ease-in duration-200'
              leaveFrom='opacity-100'
              leaveTo='opacity-0'>
              <div
                className='fixed w-screen h-screen left-0 top-0 bg-gray-500 bg-opacity-75 transition-opacity'
                aria-hidden='true'
                onClick={closeModal}
              />
            </Transition.Child>
          )}

          {/* <!-- This element is to trick the browser into centering the modal contents. --> */}
          <span
            className='hidden sm:inline-block sm:align-middle '
            aria-hidden='true'>
            &#8203;
          </span>

          <Transition.Child
            as={Fragment}
            enter='ease-out duration-300'
            enterFrom='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'
            enterTo='opacity-100 translate-y-0 sm:scale-100'
            leave='ease-in duration-200'
            leaveFrom='opacity-100 translate-y-0 sm:scale-100'
            leaveTo='opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95'>
            <div className='relative inline-block rounded-lg overflow-hidden shadow-xl transform transition-all'>
              <div className='absolute z-1 top-2 right-2'>
                <CloseIconButton onClick={closeModal} />
              </div>
              {modal.children}
            </div>
          </Transition.Child>
        </div>
      </div>
    </Transition>
  );
};
